import { offer } from '@src/api/actions';
import { getSafe } from '@src/tools/util';
export const fetchOfferList = (query) => offer.getOfferList(query).then((res) => getSafe(res, 'data'));
export const fetchQuitList = (query) => offer.getOfferList(query).then((res) => getSafe(res, 'data'));
export const addOffer = (data) => offer.addNewOffer(data);
export const offerSetInternSalaryHiddenFlagApi = (data) => offer.offerSetInternSalaryHiddenFlag(data);
